import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const Training = () => {
  const navigate = useNavigate();

  return (
    <main className="max-w-5xl mx-auto px-4 py-12">
      <header className="mb-8 text-center">
        <h1 className="text-3xl font-extrabold text-[#002a5c] mb-2">Corporate Trainings</h1>
        <p className="text-sm text-slate-600">Practical, industry-aligned programs to upskill your team — from product design to backend systems.</p>
      </header>

      <section className="space-y-6 mb-10">
        <article className="p-6 rounded-2xl shadow-md border border-slate-200 bg-white w-full">
          <h3 className="text-lg font-bold text-[#0f172a] mb-2">FullStack Development</h3>
          <p className="text-sm text-slate-600 mb-4">End-to-end training covering modern frontend frameworks, REST/GraphQL APIs, databases, CI/CD and production readiness.</p>
          <ul className="text-sm text-slate-700 space-y-1 mb-4">
            <li>• Frontend: React, Hooks, TypeScript, Performance</li>
            <li>• Backend: Node/Express, PHP/Laravel or Python, API design</li>
            <li>• Data: Relational & NoSQL modeling, migrations</li>
            <li>• DevOps: Docker, CI/CD pipelines, monitoring</li>
          </ul>
          <button onClick={() => navigate('/trainings/fullstack', { state: { courseTitle: 'FullStack Development' } })} className="inline-flex items-center gap-2 text-sm font-semibold text-blue-600">
            Learn more <ChevronRight size={16} />
          </button>
        </article>

  <article className="p-6 rounded-2xl shadow-md border border-slate-200 bg-white w-full">
          <h3 className="text-lg font-bold text-[#0f172a] mb-2">UI/UX Design</h3>
          <p className="text-sm text-slate-600 mb-4">Practical design sprints, research methods and a design system approach to deliver delightful user experiences.</p>
          <ul className="text-sm text-slate-700 space-y-1 mb-4">
            <li>• Research: user interviews, journey mapping</li>
            <li>• Design: Figma, prototyping, interaction patterns</li>
            <li>• Systems: component libraries and accessibility</li>
            <li>• Handoff: design tokens, collaboration with engineering</li>
          </ul>
          <button onClick={() => navigate('/trainings/uiux', { state: { courseTitle: 'UI/UX Design' } })} className="inline-flex items-center gap-2 text-sm font-semibold text-blue-600">
            Learn more <ChevronRight size={16} />
          </button>
        </article>

  <article className="p-6 rounded-2xl shadow-md border border-slate-200 bg-white w-full">
          <h3 className="text-lg font-bold text-[#0f172a] mb-2">Backend Development</h3>
          <p className="text-sm text-slate-600 mb-4">Robust server-side architectures, API best practices, scalability patterns and secure engineering for production systems.</p>
          <ul className="text-sm text-slate-700 space-y-1 mb-4">
            <li>• Architecture: microservices vs monoliths, scalability</li>
            <li>• APIs: REST vs GraphQL, versioning, rate limiting</li>
            <li>• Reliability: testing strategies, observability</li>
            <li>• Security: auth, input validation, secrets management</li>
          </ul>
          <button onClick={() => navigate('/trainings/backend', { state: { courseTitle: 'Backend Development' } })} className="inline-flex items-center gap-2 text-sm font-semibold text-blue-600">
            Learn more <ChevronRight size={16} />
          </button>
        </article>
      </section>

      <section id="contact" className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-100">
        <h4 className="text-lg font-semibold mb-2">Get this training for your team</h4>
        <p className="text-sm text-slate-700 mb-4">Tell us your team size and goals — we'll propose a tailored syllabus, schedule and pricing.</p>
        <div className="grid md:grid-cols-3 gap-3">
          <input placeholder="Company / Team" className="p-3 rounded-xl border border-slate-200" />
          <input placeholder="Contact name" className="p-3 rounded-xl border border-slate-200" />
          <input placeholder="Phone / Email" className="p-3 rounded-xl border border-slate-200" />
        </div>
        <div className="mt-4 flex gap-3">
          <button className="px-4 py-2 bg-blue-600 text-white rounded-xl font-semibold">Request Proposal</button>
          <Link to="/contact" className="px-4 py-2 border border-slate-300 rounded-xl text-sm">Contact Us</Link>
        </div>
      </section>
    </main>
  );
};

export default Training;
